export default {
  'Choose File': '시작하기',
  'Please paste a URL': 'URL을 붙여넣으십시오.',
  'Loading': '로딩 중',
  'Analyzing': '해석중입니다.',
  'Try a sample': '샘플을 사용해 보십시오.',
  'Sorry, error occurs when analyzing the URL.': '죄송합니다. URL을 분석할 때 오류가 발생합니다.',
}